import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '@store/constants';

import * as cartQuantityActions from './actions/cartQuantityActions';
import { prepareWithCart } from './actions/prepareActions';

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    prepareWithCart,
    ...cartQuantityActions,
  },
});

export const cartActions = cartSlice.actions;

export default cartSlice.reducer;
